import { createStore } from 'vuex'

export default createStore({
  state:{
	// popshow:true,//弹窗
  },
  mutations: {
	// setPopshow(state, status){
	// 	state.popshow = status;
	// }
  },
  actions: {
  },
  modules: {
  }
})
